<template>
  <app-layout>
    <content-card>
      <h3 slot="title">{{ $t('title404') }}</h3>

      <p slot="content">
        {{ $t('content404') }}
      </p>
    </content-card>

    <step-publish
        :button-text="buttonText"
        :is-button-disabled="false"
        :class-object="{'card-white': true}"
        :redirect-url="redirectUrl">
      <template slot="stats">
        <slot name="stats" />
      </template>
    </step-publish>
  </app-layout>
</template>

<script>
import ContentCard from '../content/ContentCard'
import StepPublish from '../step/StepPublish'
import AppLayout from '../layout/AppLayout'

export default {
  name: "PageNotFound",
  components: {
    ContentCard,
    StepPublish,
    AppLayout,
  },
  data() {
    return {
      buttonText: this.$t('pageNotFound.buttonText'),
      redirectUrl: '/',
    }
  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/layout/PageNotFound.vue